import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'

const queryClient = new QueryClient()

const theme = createTheme({
  typography: {
    fontFamily: 'Montserrat, Arial, sans-serif',
  },
  palette: {
    primary: { main: '#e9e7e1' },
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#629A41',
          margin: `0px!important`,
          padding: 0,
          transition: 'none!important',
          pointerEvents: 'none',
        },
        popper: {
          position: 'relative',
          display: 'inline-block',
          maxWidth: 186,
          backgroundColor: '#629A41',
          color: '#e9e7e1',
          padding: 8,
          margin: `0px!important`,
          fontSize: '13px',
          textAlign: 'left',
          fontFamily: 'Montserrat',
          height: 'fit-content',
          pointerEvents: 'none',
          '&:after': {
            content: '""',
            position: 'absolute',
            top: '100%',
            right: '0%',
            marginLeft: '-5px',
            borderWidth: '5px',
            borderStyle: 'solid',
            borderColor: '#629A41 #629A41 transparent transparent',
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          backgroundColor: '#222222',
          padding: '0px',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: '0px 8px 0px 0px',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#629A41',
          fontFamily: 'Montserrat',
          fontSize: '12px',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          textTransform: 'uppercase',
          fontSize: '14px',
          fontWeight: '600',
          whiteSpace: 'nowrap',
          border: 'none',
        },
        body: {
          border: '1px solid #000000',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        outlinedPrimary: {
          textTransform: 'uppercase',
          fontSize: '12px',
          border: '2px solid #E9E7E1',
          width: 'fit-content',
          padding: '8px 16px',
          color: '#E9E7E1',
          borderRadius: '0px',
        },
        outlinedSecondary: {
          textTransform: 'uppercase',
          fontSize: '12px',
          border: '2px solid #E9E7E1',
          width: '100%',
          padding: '8px 16px',
          color: '#E9E7E1',
          borderRadius: '0px',
          textAlign: 'left',
          fontWeight: 'bold',
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          // marginTop: '10px',
          // position: 'relative',
          // display: 'inline-block',
          // maxWidth: '186px',
          // backgroundColor: '#da9b28',
          // color: '#e9e7e1',
          // padding: '8px',
          // fontSize: '13px',
          // textAlign: 'center',
          '&:after': {
            content: '""',
            position: 'absolute',
            top: '100%',
            right: '0%',
            marginLeft: '-5px',
            borderWidth: '5px',
            borderStyle: 'solid',
            borderColor: '#629A41 #629A41 transparent transparent',
          },
        },
        paper: {},
      },
    },
  },
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
)
